module.exports = __webpack_public_path__ + "static/media/logoResidence.4c246b73.png";